import { useTranslation } from 'react-i18next'
import { setAppLanguage, type AppLanguage } from '@/lib/i18n'
import { cn } from '@/lib/utils/cn'

/* ------------------------------------------------------------------ */
/*  LanguageToggle, minimal single-toggle language switch              */
/*  Shows only the active language as two lowercase letters (sv / en). */
/*  Clicking instantly flips to the other language.                    */
/* ------------------------------------------------------------------ */

const NEXT: Record<AppLanguage, AppLanguage> = { sv: 'en', en: 'sv' }

export interface LanguageToggleProps {
  className?: string
}

export function LanguageToggle({ className }: LanguageToggleProps) {
  const { i18n } = useTranslation()
  const current: AppLanguage = i18n.language === 'en' ? 'en' : 'sv'
  const next = NEXT[current]

  return (
    <button
      type="button"
      onClick={() => setAppLanguage(next)}
      className={cn(
        'inline-flex h-8 w-8 items-center justify-center rounded-lg text-sm font-semibold lowercase',
        'text-neutral-700 transition-colors hover:bg-neutral-100 hover:text-neutral-900',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
        className,
      )}
      aria-label={next === 'en' ? 'Switch to English' : 'Byt till svenska'}
      title={next === 'en' ? 'Switch to English' : 'Byt till svenska'}
    >
      {current}
    </button>
  )
}

LanguageToggle.displayName = 'LanguageToggle'
